<template>
  <v-row justify="start" align="start">
    <v-col
      v-if="
        this.$store.getters.retrieveIsCashCustomer ||
        this.$store.getters.retrieveIsCncCustomer
      "
      cols="12"
      md="12"
      sm="12"
    >
      <CncSwitch></CncSwitch>
      <CncAddress class="mt-4"></CncAddress>
    </v-col>

    <v-col
      cols="12"
      md="12"
      sm="12"
      class="py-0"
      v-if="$store.getters.retrieveAnon"
    >
      <ChangePostcode />
    </v-col>

    <v-col cols="12" md="12" sm="12">
      <DateAlert class="mb-4"></DateAlert>
      <CutOff class="mb-4"></CutOff>

      <MandatoryCategory
        class="mb-4"
        :isStandingOrder="false"
      ></MandatoryCategory>
    </v-col>

    <v-col cols="12" lg="8" sm="12" class="pt-0">
      <v-row justify="space-between" align="center">
        <v-col v-if="totalBasketItems" cols="12" lg="12" sm="12" class="pa-0">
          <v-banner icon="shopping_cart">
            Your Basket
            <template v-slot:actions>
              <v-row justify="end" align="end">
                <v-col
                  md="auto"
                  v-if="totalBasketItems && !$store.getters.retrieveAnon"
                >
                  <v-btn
                    outlined
                    color="blue darken-2"
                    @click="saveAsTemplateDialog = true"
                    :block="$vuetify.breakpoint.mdAndDown"
                  >
                    <v-icon left>save</v-icon>Save as Template
                  </v-btn>
                </v-col>
                <v-col
                  md="auto"
                  v-if="$store.getters.retrieveHasMultipleTrollys"
                >
                  <v-btn
                    outlined
                    color="blue darken-2"
                    :to="{ name: 'OrdersBasketSelection' }"
                    :block="$vuetify.breakpoint.mdAndDown"
                  >
                    <v-icon left>shopping_cart</v-icon>Change Basket
                  </v-btn>
                </v-col>
              </v-row>
            </template>
          </v-banner>
        </v-col>
        <v-col v-if="totalBasketItems" cols="12" lg="12" sm="12" class="pa-0">
          <v-card
            v-if="loadingBaskets"
            :loading="loadingBaskets ? 'blue darken-2' : null"
            flat
          >
            <!-- <template slot="progress">
              <v-progress-linear color="blue darken-2" indeterminate />
            </template> -->
            <v-card-text>Refreshing your basket </v-card-text>
          </v-card>
        </v-col>

        <MinimumValue />

        <MaximumValue />

        <MaximumBudgetValue />
        <AgeRestrictedProduct />

        <!-- <v-col v-if="totalBasketItems" cols="12" lg="5" sm="12">
          <v-row justify="space-between" align="center">
            <v-col v-if="totalBasketItems" cols="12" lg="6" sm="12">
              <div class="subtitle-2">No. Items: {{ totalBasketItems }}</div>
            </v-col>
            <v-col v-if="totalBasketItems" cols="12" lg="6" sm="12">
              <div class="subtitle-2">Total Quantity: {{ totalQty }}</div>
            </v-col>
          </v-row>
        </v-col>

        <v-col v-if="totalBasketItems" cols="12" lg="4" sm="12">
          <div class="subtitle-2" style="text-align: end">
            Total Value: £{{ basketTotal }}
          </div>
        </v-col> -->

        <v-col v-if="totalBasketItems" cols="12">
          <v-subheader style="width: 100%"><b>Basket Totals</b></v-subheader>

          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Name</th>
                  <th class="text-left">No. Items</th>
                  <th class="text-left">Total Qty</th>
                  <th class="text-right">Total Value</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Net Total</td>
                  <td>{{ totalBasketItems }}</td>
                  <td>{{ totalQty }}</td>
                  <td class="text-right">
                  <template v-if="retrieveShowPrices">
                    £{{
                      parseFloat(
                        $store.getters.retrieveCurrentTrolly
                          .trolly_value_minus_vat
                      ).toFixed(2)
                    }}
                    </template>
                  </td>
                </tr>
                <tr v-if="$store.getters.retrieveCurrentTrolly">
                  <td>VAT</td>
                  <td></td>
                  <td></td>
                  <td class="text-right">
                  <template  v-if="retrieveShowPrices">
                    £{{
                      parseFloat(
                        $store.getters.retrieveCurrentTrolly.trolly_vat
                      ).toFixed(2)
                    }}
                    </template>
                  </td>
                </tr>
                <tr
                  v-if="
                    $store.getters.retrieveCurrentTrollyDiscountEnabled &&
                    $store.getters.retrieveCurrentTrolly.order_discount
                      .discount_id
                  "
                >
                  <td>Discount Amount</td>
                  <td></td>
                  <td></td>
                  <td class="text-right">
                    -£{{ $store.getters.retrieveCurrentTrollyDiscountAmount }}
                  </td>
                </tr>
                <tr
                  v-if="
                    $store.getters.retrieveCurrentTrollyDiscountEnabled &&
                    $store.getters.retrieveCurrentTrolly.order_discount
                      .discount_id
                  "
                >
                  <td>Discount VAT Reduction</td>
                  <td></td>
                  <td></td>
                  <td class="text-right">
                    -£{{ $store.getters.retrieveCurrentTrollyDiscountVAT }}
                  </td>
                </tr>
                <tr>

                  <td>Grand Total</td>
                  <td></td>
                  <td></td>
                  <td class="text-right" v-if="retrieveShowPrices == true">
                    £{{
                      parseFloat(
                        $store.getters.retrieveCurrentTrolly.grand_total
                      ).toFixed(2)
                    }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>

        <v-col
          v-if="
            totalBasketItems && $store.getters.retrieveOrderDiscountsEnabled
          "
          cols="12"
          class="py-0"
        >
          <OrderDiscounts />
        </v-col>

        <!-- <v-col v-if="totalBasketItems" cols="12" lg="4" sm="12">
          <div class="subtitle-2" style="text-align: end">
            Total Value: £{{ basketTotal }}
          </div>
        </v-col> -->

        <v-col v-if="!totalBasketItems" cols="12" lg="12" sm="12">
          <v-banner icon="shopping_cart">
            Your Basket is empty
            <template v-slot:actions>
              <v-btn
                v-if="$store.getters.retrieveHasMultipleTrollys"
                outlined
                color="blue darken-2"
                :to="{ name: 'OrdersBasketSelection' }"
              >
                <v-icon left>shopping_cart</v-icon>Change Basket
              </v-btn>
            </template>
          </v-banner>
          <v-progress-linear
            v-if="loadingBaskets"
            color="blue darken-2"
            indeterminate
          ></v-progress-linear>
        </v-col>
        <v-col
          v-else
          v-for="distNo in Object.keys(basketItems)"
          :key="distNo"
          cols="12"
        >
          <v-row
            justify="start"
            align="start"
            v-if="Object.keys(basketItems).length > 1"
          >
            <v-subheader class="mx-6" style="width: 100%">
              <b>{{
                `Distributor: ${basketItems[distNo].distributor_name}`
              }}</b>
            </v-subheader>
          </v-row>
          <v-simple-table dense v-if="Object.keys(basketItems).length > 1">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">No. Items</th>
                  <th class="text-left">Total Qty</th>
                  <th class="text-right">Total Value</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ basketItems[distNo].distItems }}</td>
                  <td>{{ basketItems[distNo].distQty }}</td>
                  <td class="text-right">
                    £{{ basketItems[distNo].distValue }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-col
            v-for="product in basketItems[distNo].items"
            :key="product.id"
            cols="12"
            class="px-0"
          >
            <ProductBasket
              v-if="product.prod_desc"
              @selectProduct="loadSelectedProduct($event)"
              @deleteTrollyItem="updateDeleteItemDialog($event)"
              v-bind:product="product"
              v-bind:visible="true"
            ></ProductBasket>
          </v-col>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" md="4" sm="12" class="hidden-md-and-down">
      <v-row justify="center" align="center">
        <v-col v-if="$store.getters.retrieveAnon" cols="12" lg="12" sm="12">
          <v-btn
            :to="{ name: 'OrdersPreCheckout' }"
            block
            large
            color="blue darken-2"
            class="white--text"
            :disabled="disableAnonSubmit"
          >
            Checkout
          </v-btn>
        </v-col>

        <v-col v-else cols="12" lg="12" sm="12">
          <v-btn
            color="blue darken-2"
            class="white--text"
            @click="preCheckoutChecks()"
            block
            large
            :disabled="disableSubmit"
            :loading="submitLoading || loadingBaskets"
          >
            <span>Proceed to Checkout</span>
          </v-btn>
        </v-col>

        <v-col v-if="$store.getters.retrieveAnon" cols="12" lg="12" sm="12">
          <span class="text--secondary">Already have an account?</span>
          <Convert :bottom="false" />
        </v-col>

        <v-col cols="12" lg="12" sm="12">
          <v-btn
            color="blue darken-2"
            exact
            :to="{ name: OrderHereLink }"
            block
            outlined
            large
            :loading="submitLoading || loadingBaskets"
          >
            <span>{{ OrdersSearchText.Full }}</span>
          </v-btn>
        </v-col>

        <v-col cols="12" lg="12" sm="12">
          <v-btn
            color="blue darken-2"
            exact
            :to="{ name: 'OrdersCreate' }"
            :disabled="disableCancel"
            block
            outlined
            large
            :loading="submitLoading || loadingBaskets"
          >
            <span>Change Delivery Details</span>
          </v-btn>
        </v-col>
        <v-col cols="12" lg="12" sm="12">
          <v-btn
            color="error"
            :loading="loadingCancelOrder || submitLoading || loadingBaskets"
            @click="cancelOrderDialog = true"
            block
            outlined
            large
            :disabled="disableCancel"
          >
            <span>Cancel Order</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-col>

    <v-dialog v-model="deleteItemDialog" persistent max-width="400">
      <v-card color="background">
        <v-toolbar color="background" flat dense>
          <v-toolbar-title>Delete Item</v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="deleteItemDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <div class="pa-4">
          <ProductName :product="selectedProduct"></ProductName>
        </div>
        <v-card-subtitle
          >Are you sure you want to delete this item from your
          basket?</v-card-subtitle
        >
        <v-card-actions class="dialogActions">
          <v-btn text @click="deleteItemDialog = false">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn outlined color="error" @click="delTrollyItem()">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="cancelOrderDialog" persistent max-width="400">
      <v-card>
        <v-toolbar color="background" flat dense>
          <v-toolbar-title>Cancel Order</v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="cancelOrderDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-subtitle class="mt-4">
          Are you sure you want to cancel your order?
          <br />This will remove all items from your basket
        </v-card-subtitle>
        <v-card-actions class="dialogActions">
          <v-btn text @click="cancelOrderDialog = false">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn outlined color="error" @click="delTrolly()">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="saveAsTemplateDialog" persistent max-width="400">
      <v-card>
        <v-toolbar color="background" flat dense>
          <v-toolbar-title>Save as Template</v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="saveAsTemplateDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-subtitle class="mt-4"
          >Saving this order as a template will allow you to load the all of the
          products on the search screen at a later date.</v-card-subtitle
        >
        <v-form ref="saveTemplateForm" @submit.prevent="saveToTemplate()">
          <v-text-field
            v-model="templateName"
            style="padding: 0 16px"
            :rules="nameRules"
            type="text"
            label="Template Name"
            @focus="$event.target.select()"
            outlined
            persistent-hint
            hint="Name to identify Template"
            maxlength="40"
            counter
            color="blue darken-2"
            class="my-2"
          ></v-text-field>
          <v-card-actions class="dialogActions">
            <v-btn text @click="saveAsTemplateDialog = false">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              :loading="templateSaving"
              outlined
              color="blue darken-2"
              type="submit"
              >Save</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-bottom-navigation
      app
      inset
      fixed
      grow
      color="primary"
      class="hidden-lg-and-up"
    >
      <v-btn
        :loading="loadingCancelOrder || submitLoading || loadingBaskets"
        @click="cancelOrderDialog = true"
        :disabled="disableCancel"
        style="width: 60px; min-width: 60px !important"
      >
        <span>Cancel</span>
        <v-icon>delete</v-icon>
      </v-btn>

      <v-btn
        exact
        :to="{ name: OrderHereLink }"
        style="width: 60px; min-width: 60px !important"
        :loading="submitLoading || loadingBaskets"
      >
        <span>{{ OrdersSearchText.Bottom }}</span>
        <v-icon>add_shopping_cart</v-icon>
      </v-btn>

      <v-btn
        exact
        :to="{ name: 'OrdersCreate' }"
        :disabled="disableCancel"
        style="width: 60px; min-width: 60px !important"
        :loading="submitLoading || loadingBaskets"
      >
        <span>Details</span>
        <v-icon>edit</v-icon>
      </v-btn>

      <Convert v-if="$store.getters.retrieveAnon" :bottom="true" />

      <v-btn
        v-if="$store.getters.retrieveAnon"
        style="height: 100%; width: 60px; min-width: 60px !important"
        :disabled="disableAnonSubmit"
        :to="{ name: 'OrdersPreCheckout' }"
      >
        <span>Checkout</span>
        <v-icon>check_circle_outline</v-icon>
      </v-btn>

      <v-btn
        v-else
        @click="preCheckoutChecks()"
        :loading="submitLoading || loadingBaskets"
        :disabled="disableSubmit"
        style="width: 60px; min-width: 60px !important"
      >
        <span>Checkout</span>
        <v-icon>check_circle_outline</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </v-row>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
import CncSwitch from "@/components/order/CncSwitch.vue";
import CncAddress from "@/components/order/CncAddress.vue";
import MandatoryCategory from "@/components/order/MandatoryCategory.vue";
import DateAlert from "@/components/order/DateAlert.vue";

import ChangePostcode from "@/components/auth/anon/ChangePostcode.vue";

import OrderDiscounts from "@/components/order/Discounts.vue";

import MinimumValue from "@/components/order/MinimumValue.vue";
import MaximumValue from "@/components/order/MaximumValue.vue";
import MaximumBudgetValue from "@/components/order/MaximumBudgetValue.vue";

import ProductBasket from "@/components/order/search/ProductBasket.vue";
import ProductName from "@/components/product/ProductName.vue";
import CutOff from "@/components/order/Cutoff.vue";

import Convert from "@/components/auth/anon/Convert.vue";
import AgeRestrictedProduct from "@/components/order/AgeRestrictedProduct.vue";

export default {
  name: "Basket",

  components: {
    CncSwitch,
    CncAddress,
    MandatoryCategory,
    DateAlert,
    OrderDiscounts,
    MinimumValue,
    MaximumValue,
    MaximumBudgetValue,
    ProductBasket,
    ProductName,
    CutOff,
    ChangePostcode,
    Convert,
    AgeRestrictedProduct,
  },

  data() {
    return {
      deleteItemDialog: false,
      selectedProduct: null,

      cancelOrderDialog: false,

      saveAsTemplateDialog: false,
      templateSaving: false,
      templateName: "",
      nameRules: [(v) => !!v || "Name Required"],

      loadingBaskets: false,
      loadingCancelOrder: false,
      loadingDelete: false,
      submitLoading: false,
    };
  },

  methods: {
    ...mapActions([
      "setSnackbar",
      "getTrollys",
      "orderBeingPaidForAction",
      "cloneTrolly",
      
    ]),


    loadSelectedProduct(newProduct) {
      this.selectedProduct = newProduct;
    },

    updateDeleteItemDialog(newProduct) {
      this.selectedProduct = newProduct;
      this.deleteItemDialog = true;
    },

    async preCheckoutChecks() {
      // this.submitLoading = true;
      // let checksError = false;
      // let checksMessage = "";

      // let payload = JSON.stringify({
      //   sessionKey: this.$store.getters.retrieveUser.sessionKey,
      //   userId: this.$store.getters.retrieveUser.userNum,
      //   trollyId: this.$store.getters.retrieveCurrentTrolly.id,
      // });

      // const params = new URLSearchParams();
      // params.append("params", payload);

      // await axios
      //   .post("get-stock", params, { timeout: 5000 })
      //   .then((response) => {
      //     if (response.data.success) {
      //       //this.setSnackbar({ text: "Item deleted from basket" });
      //     } else {
      //       // this.setSnackbar({
      //       //   color: "error",
      //       //   text: "Error adding item to basket"
      //       // });

      //       if (
      //         response.data.message !=
      //         "Network error talking to backend issac system"
      //       ) {
      //         checksError = true;
      //         checksMessage += response.data.message;
      //       }
      //     }
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });

      // if (checksError == false) {
      //   this.$router.push({ name: "OrdersCheckout" });
      // } else {
      //   console.log(checksMessage);
      //   this.setSnackbar({
      //     color: "error",
      //     text: checksMessage,
      //   });
      // }

      this.$router.push({ name: "OrdersCheckout" });
      // this.submitLoading = false;
    },

    async refreshBasket() {
      console.log("-- Close Popups");
      this.loadingBaskets = true;
      this.deleteItemDialog = false;

      console.log("-- Refresh Basket");
      await this.getTrollys()
        .then((response) => {
          console.log("-- Got Trollys");
          console.log(response);
        })
        .catch((er) => {
          console.log(er);
        });

      this.loadingBaskets = false;
    },

    async delTrollyItem() {
      console.log("Delete Item");
      this.loadingDelete = true;

      let stringPayload = JSON.stringify({
        sessionKey: this.$store.getters.retrieveUser.sessionKey,
        userId: this.$store.getters.retrieveUser.userNum,
        trollyId: this.$store.getters.retrieveCurrentTrolly.id,
        trollyItemId: this.selectedProduct.id,
        // prodNo: this.selectedProduct.prod_no,
        // qtyType: this.selectedProduct.qty_type
      });

      const params = new URLSearchParams();
      params.append("params", stringPayload);

      await axios
        .post("del-trolly-item", params)
        .then((response) => {
          if (response.data.success) {
            this.setSnackbar({ text: "Item deleted from basket" });
            this.refreshBasket();
          } else {
            this.setSnackbar({
              color: "error",
              text: "Error deleting item from basket",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });

      this.loadingDelete = false;
    },

    async delTrolly() {
      console.log("Delete Trolly");
      this.loadingCancelOrder = true;

      let stringPayload = JSON.stringify({
        sessionKey: this.$store.getters.retrieveUser.sessionKey,
        userId: this.$store.getters.retrieveUser.userNum,
        trollyId: this.$store.getters.retrieveCurrentTrolly.id,
      });

      const params = new URLSearchParams();
      params.append("params", stringPayload);

      await axios
        .post("del-trolly", params)
        .then((response) => {
          if (response.data.success) {
            this.setSnackbar({ text: "Order Cancelled" });
            this.refreshBasket();
          } else {
            this.setSnackbar({
              color: "error",
              text: "Error cancelling order",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });

      this.cancelOrderDialog = false;
      this.loadingCancelOrder = false;
    },

    async saveToTemplate() {
      this.templateSaving = true;

      if (this.$refs.saveTemplateForm.validate()) {
        let orderObject = {
          trollyId: this.$store.getters.retrieveCurrentTrolly.id,
          name: this.templateName,
          template: 1,
        };

        let response = await this.cloneTrolly(orderObject);

        if (response) {
          this.setSnackbar({ text: "Saved as Template" });
          this.saveAsTemplateDialog = false;
        } else {
          this.setSnackbar({
            color: "error",
            text: "Error saving template",
          });
        }
      }

      this.templateSaving = false;
    },
  },

  computed: {

 ...mapGetters(["retrieveShowPrices"]),

    disableAnonSubmit() {
      if (this.$store.getters.retrieveCurrentTrolly) {
        return !this.$store.getters.retrieveCurrentTrolly.trolly_valid_anon;
      } else {
        return true;
      }
    },
    

    isAccountCustomer() {
      if (
        !this.$store.getters.retrieveIsCncCustomer &&
        !this.$store.getters.retrieveIsCashCustomer
      ) {
        return true;
      } else {
        return false;
      }
    },

    OrdersSearchText() {
      let searchText = {};

      if (this.$store.getters.retrieveCurrentTrolly) {
        if (
          Object.keys(this.$store.getters.retrieveCurrentTrolly.trolly_items)
            .length > 0
        ) {
          searchText.Full = "Continue Shopping";
          searchText.Bottom = "Shop";
        } else {
          searchText.Full = "Start Shopping";
          searchText.Bottom = "Search";
        }
      } else {
        searchText.Full = "Start Shopping";
        searchText.Bottom = "Shop";
      }

      return searchText;
    },

    disableSubmit() {
      return !this.$store.getters.retrieveCurrentTrolly.valid;
    },

    disableCancel() {
      if (this.$store.getters.retrieveCurrentTrolly) {
        return false;
      } else {
        return true;
      }
    },

    totalBasketItems() {
      if (this.$store.getters.retrieveCurrentTrolly) {
        if (
          Object.keys(this.$store.getters.retrieveCurrentTrolly.trolly_items)
            .length > 0
        ) {
          // return Object.keys(
          //   this.$store.getters.retrieveCurrentTrolly.trolly_items
          // ).length;
          return this.$store.getters.retrieveCurrentTrolly.totalItems;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    totalQty() {
      if (this.$store.getters.retrieveCurrentTrolly) {
        return this.$store.getters.retrieveCurrentTrolly.totalQty;
      } else {
        return 0;
      }
    },

    basketItems() {
      if (this.totalBasketItems) {
        return this.$store.getters.retrieveCurrentTrolly.trolly_items;
      } else {
        return false;
      }
    },

    basketTotal() {
      if (this.totalBasketItems) {
        return this.$store.getters.retrieveCurrentTrolly.totalValue;
      } else {
        return false;
      }
    },

    OrderHereLink() {
      console.log("-- Checking Order Here Link");
      console.log(this.$store.getters.retrieveCurrentTrolly);

      if (this.$store.getters.retrieveCurrentTrolly) {
        return "OrdersSearch";
      } else {
        return "OrdersCreate";
      }
    },

    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },

    cardActionsStyle() {
      const Style = {
        background: this.$vuetify.theme.themes[this.theme].background_off,
      };
      return Style;
    },
  },

  activated() {
    this.refreshBasket();
  },
};
</script>

<style lang="sass" scoped>
</style>